export default __webpack_public_path__ + "static/media/collaborating2.c4b3a028.svg";